import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { apiClient, getErrorMessage } from "../../shared";
import { ExpenseCategoryFormDialog } from "../expense-category-form-dialog";
import { useSnackbar } from "../../ui";

import { Button } from "@mui/material";

export const EditExpenseCategoryFormDialog = ({
  isOpen,
  onClose,
  expenseCategoryId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchProductCategory = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, status, chartOfAccount },
          },
        } = await apiClient.get(`expense-categories/${expenseCategoryId}`);
        setDefaultValues({
          name,
          status,
          chartOfAccount: chartOfAccount || null,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductCategory();
  }, [isOpen, expenseCategoryId]);

  const handleSubmit = async ({ name, status, chartOfAccountId }) => {
    try {
      await apiClient.put(`expense-categories/${expenseCategoryId}`, {
        name,
        status,
        chartOfAccountId,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui kategori biaya"));

      throw error;
    }
  };

  return (
    <ExpenseCategoryFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Ubah Kategori Biaya"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditExpenseCategoryFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  expenseCategoryId: PropTypes.string,
};
